import React from 'react';
import Page from "../Page";
import {LoadingWrapper} from "../LoadingWrapper";
import ReactTable from "../ReactTable";
import {useServiceBase} from "../ReactTable/useServiceBase";
import {faIcons} from "../../../utils/iconConstants";

const LastProductionDeployment = () => {

    const endpointUrl = `${process.env.REACT_APP_EDP_API_BASE_URL}/lastProductionDeployment`;
    const {loading, data} = useServiceBase({endpointUrl});

    const customColumns = [
        {
            header: 'Repo', accessorKey: 'repo',
            cell: ({getValue, row}) => <a href={`https://app.circleci.com/pipelines/bitbucket/spinsllc/${getValue()}?branch=${row.original.branch}`}
                                     target="_blank" rel="noopener noreferrer">{getValue()}</a>
        },
        {header: 'Approval Date', accessorKey: 'date', accessorFn: row => row.date || 'N/A 90 days'},
        {
            header: 'Number Of Days', id: 'numberOfDays',
            accessorFn: row => row.numberOfDays ?? 'N/A',
            sortingFn: (rowA, rowB, columnId) => {
                const rowBValue = rowB.getValue(columnId);
                const rowAValue = rowA.getValue(columnId);
                return (rowBValue === 'N/A') - (rowAValue === 'N/A') || (-(rowAValue < rowBValue) || +(rowAValue > rowBValue));
            },
        },
        {
            header: 'Prod Deploys (last 30 days)', id: 'deploysLast30Days',
            accessorFn: row => row.deploysLast30Days ?? 'N/A',
            sortingFn: (rowA, rowB, columnId) => {
                const rowBValue = rowB.getValue(columnId);
                const rowAValue = rowA.getValue(columnId);
                return (rowBValue === 'N/A') - (rowAValue === 'N/A') || (-(rowAValue < rowBValue) || +(rowAValue > rowBValue));
            }
        },
        {header: 'Workflow ID', accessorKey: 'workflowId'},
    ]

    return <Page name={'Last Production Deployment'}
                 headerSubComponent={<a href={`/circleCiRepos`} target="_blank" rel="noopener noreferrer"
                                        title={"Circle Ci Repos"} className={faIcons.gear}/>}>
        <LoadingWrapper loading={loading}>
            <ReactTable filterable
                        data={data}
                        columns={customColumns}
                        initialState={{sorting: [{id: 'numberOfDays', desc: true}], pagination: {pageSize: 25}}}
            />
        </LoadingWrapper>
    </Page>;
};


export default LastProductionDeployment;